<ng-container [formGroup]="formGroup">
  <mat-form-field>
    <mat-label>{{ 'areas.overlapping.fields.NAME' | transloco }}</mat-label>
    <input matInput formControlName="formula" />
  </mat-form-field>
</ng-container>
